import { goClient } from '../utils/httpClientTs';

export interface LockdownCreateResponse {
  token: string;
  request_id: string;
}

export interface LockdownDecryptResponse {
  plaintext: string;
  request_id: string;
}

export interface LockdownRotateResponse {
  token: string;
  request_id: string;
}

export async function lockdownTestCreate(
  plaintext: string
): Promise<LockdownCreateResponse> {
  const { data } = await goClient.post<LockdownCreateResponse>(
    '/api/lockdown-test/secrets',
    { plaintext }
  );
  return data;
}

export async function lockdownTestDecrypt(
  token: string
): Promise<LockdownDecryptResponse> {
  const { data } = await goClient.post<LockdownDecryptResponse>(
    '/api/lockdown-test/secrets/decrypt',
    { token }
  );
  return data;
}

export async function lockdownTestRotate(
  token: string,
  plaintext: string
): Promise<LockdownRotateResponse> {
  const { data } = await goClient.put<LockdownRotateResponse>(
    `/api/lockdown-test/secrets/${encodeURIComponent(token)}`,
    { plaintext }
  );
  return data;
}

export async function lockdownTestRevoke(token: string): Promise<void> {
  await goClient.delete(
    `/api/lockdown-test/secrets/${encodeURIComponent(token)}`
  );
}
